import { UseQueryResult, useQuery } from 'react-query';
import { AllEntityStatusValues } from '@cbinsights/cbientityservice/cbientityservice';
import { EntityServicesKeys } from './UseSearchForEntity';
import { getAllEntityStatusValues } from '../apis/GetAllEntityStatusValues';

export const useGetAllEntityStatusValues = ({
  enabled,
}: {
  enabled: boolean;
}): UseQueryResult<AllEntityStatusValues, Error> =>
  useQuery<
    AllEntityStatusValues,
    Error,
    AllEntityStatusValues,
    [EntityServicesKeys]
  >(['AllEntityStatusValues'], () => getAllEntityStatusValues(), {
    notifyOnChangeProps: ['data', 'isFetching', 'isFetchedAfterMount'],
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    enabled,
  });
